import { Navigate, useLocation, useParams } from "react-router-dom";

export function legacyRecordDestination(
  path: string,
  search: string,
  vendorId?: string,
) {
  const params = new URLSearchParams(search);
  if (path === "/vendors/new") return "/records/vendors/new";
  if (vendorId) return `/records/vendors/${encodeURIComponent(vendorId)}/edit`;
  if (path === "/vendors") {
    params.set("type", "vendor");
    return `/records?${params}`;
  }
  if (path === "/ap-postings") {
    params.set("type", "ap_posting");
    return `/records?${params}`;
  }
  if (path === "/upload") params.set("upload", "true");
  const type = params.get("document_type");
  const approval =
    params.get("extraction_status") === "pending_review" ||
    params.get("review_stage") === "approval_progress";
  if (approval) {
    params.set(
      "type",
      ["invoice", "receipt", "purchase_order"].includes(type ?? "")
        ? type!
        : "all",
    );
  } else {
    params.set("type", "documents");
  }
  return `${approval ? "/approvals" : "/records"}?${params}`;
}

export function LegacyRecordRedirect() {
  const { pathname, search } = useLocation();
  const { vendorId } = useParams();
  return (
    <Navigate
      to={legacyRecordDestination(pathname, search, vendorId)}
      replace
    />
  );
}
